import { getConstant } from '../utils';

export const getInterpretation = getConstant('GET_INTERPRETATION');
export const getInterpretations = getConstant('GET_INTERPRETATIONS');
export const clearInterpretation = getConstant('CLEAR_INTERPRETATION');
export const updateInterpretation = getConstant('UPDATE_INTERPRETATION');
export const addInterpretation = getConstant('ADD_INTERPRETATION');
